// A deploy deletes the previous build's hashed files, so a tab opened before it 404s on the next
// lazy page. One reload fetches the new index.html; the guard stops a loop if the file is really gone.
const RELOAD_KEY = "stale-build-reload-at";
const RELOAD_GUARD_MS = 30_000;

const CHUNK_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

export const isStaleBuildError = (error: unknown): boolean =>
  error instanceof Error && CHUNK_ERROR.test(error.message);

/** Reloads once per 30 s; returns false when it already did, so the caller shows the error. */
export const reloadForStaleBuild = (): boolean => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    if (Date.now() - last < RELOAD_GUARD_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // No sessionStorage: reload anyway, the browser's own loop protection applies.
  }
  window.location.reload();
  return true;
};

export const listenForStaleBuild = () => {
  window.addEventListener("vite:preloadError", (event) => {
    if (reloadForStaleBuild()) event.preventDefault();
  });
};
